import { CnFormItem } from '@/form/cn-form-item';
import { CnInput } from '@/form/cn-input';
import { CnNumberPicker } from '@/form/cn-number-picker';
import { CnOSSUpload } from '@/form/cn-oss-upload';
import { CnOSSImageUpload } from '@/form/cn-oss-image-upload';
import { CnInputTextArea } from '@/form/cn-input-textarea';
import { CnSelect } from '@/form/cn-select';
import { CnAsyncSelect } from '@/form/cn-async-select';
import { CnDepartmentSelect } from '@/form/cn-department-select';
import { CnEmployeeSelect } from '@/form/cn-employee-select';
import { CnFormGrid } from '@/form/cn-form-grid';
import { CnCard, CnCardSubCard } from '@/form/cn-card';
import { CnSwitch } from '@/form/cn-switch';
import { CnRating } from '@/form/cn-rating';
import { CnRadioGroup } from '@/form/cn-radio-group';
import { CnCascaderSelect } from '@/form/cn-cascader-select';
import { CnSelector } from '@/form/cn-selector';
import { CnFormArrayCard } from '@/form/cn-form-array-card';
import { CnTimePickerPro } from '@/form/cn-time-picker-pro';
import { CnReadOnly } from '@/form/cn-readonly';
import { CnCheckbox, CnCheckboxGroup } from '@/form/cn-checkbox-group';
import { CnDatePickerPro, CnWeekPickerPro, CnMonthPickerPro, CnYearPickerPro, } from '@/form/cn-date-picker-pro';
import { CnDateRangePickerPro } from '@/form/cn-date-range-picker-pro';
export const componentMap = {
    CnFormItem,
    CnFilterItem: CnFormItem,
    CnFilterProItem: CnFormItem,
    CnSelect,
    CnAsyncSelect,
    CnDepartmentSelect,
    CnEmployeeSelect,
    CnInput,
    CnNumberPicker,
    CnOSSUpload,
    CnOSSImageUpload,
    CnInputTextArea,
    CnFormGrid,
    CnCard,
    CnCardSubCard,
    CnSwitch,
    CnRating,
    CnRadioGroup,
    CnReadOnly,
    CnCascaderSelect,
    CnSelector,
    CnFormArrayCard,
    CnTimePickerPro,
    CnDatePickerPro,
    CnCheckbox,
    CnCheckboxGroup,
    CnWeekPickerPro,
    CnMonthPickerPro,
    CnYearPickerPro,
    CnDateRangePickerPro,
    CnRangeDatePickerPro: CnDateRangePickerPro,
};
